import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  headers: [],
  error: null,
  message: '',
};
const headerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_HEADERS_REQUEST:
    case actionTypes.CREATE_HEADERS_REQUEST:
    case actionTypes.UPDATE_HEADERS_REQUEST:
    case actionTypes.DELETE_HEADERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.CREATE_HEADERS_SUCCESS:
    case actionTypes.SINGLEADD_UNIT_SUCCESS:
    case actionTypes.UPDATE_HEADERS_SUCCESS:
      return {
        ...state,
        loading: false,
        headers: action.payload,
      };

    case actionTypes.GET_HEADERS_SUCCESS:
      return {
        ...state,
        loading: false,
        headers : action.payload,
      };

    case actionTypes.GET_HEADERS_FAILURE:
    case actionTypes.CREATE_HEADERS_FAILURE:
    case actionTypes.UPDATE_HEADERS_FAILURE:
    case actionTypes.DELETE_HEADERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default headerReducer


